/** Tokens visuais — contas financeiras (marca TNV) */
export const CONTAS_FIN_ACCENT = "#F96030";
export const CONTAS_FIN_INK = "#1a2035";

export const contasFinToolbarSx = {
  mb: 2,
  p: 2,
  borderRadius: 2,
  bgcolor: "grey.50",
  border: "1px solid",
  borderColor: "grey.200",
  borderLeft: `4px solid ${CONTAS_FIN_ACCENT}`,
};

export const modalPaperSx = {
  borderRadius: 3,
  overflow: "hidden",
  maxHeight: "92vh",
  display: "flex",
  flexDirection: "column" as const,
  width: { xs: "100%", sm: "96vw" },
  maxWidth: 560,
};

export const modalPaperWideSx = {
  ...modalPaperSx,
  maxWidth: 720,
};

export const modalContentSx = {
  px: { xs: 2.5, sm: 3 },
  py: 2.5,
  overflow: "auto",
  overflowX: "hidden",
  boxSizing: "border-box",
  width: "100%",
};

export const modalHeaderSx = {
  px: 3,
  py: 2.5,
  background: `linear-gradient(135deg, ${CONTAS_FIN_INK} 0%, #2d3561 100%)`,
  color: "#fff",
  borderBottom: `3px solid ${CONTAS_FIN_ACCENT}`,
};

export const fieldSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: 1.5,
    bgcolor: "background.paper",
    minHeight: 40,
    height: 40,
    boxSizing: "border-box",
  },
  "& .MuiOutlinedInput-input": {
    py: 0,
    px: 1.75,
    height: "100%",
    boxSizing: "border-box",
  },
  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "grey.500",
    borderWidth: 1,
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "text.secondary",
  },
  "& .MuiSelect-select": {
    py: "0 !important",
    minHeight: "0 !important",
    height: "100%",
    display: "flex",
    alignItems: "center",
    boxSizing: "border-box",
  },
};

export const switchLabelSx = {
  mx: 0,
  alignItems: "center",
  gap: 1,
  "& .MuiFormControlLabel-label": {
    fontSize: "0.875rem",
    lineHeight: 1.4,
  },
};

export const saveButtonSx = {
  background: `linear-gradient(195deg, ${CONTAS_FIN_ACCENT}, #e04a1a)`,
};
